import type {CSSProperties} from 'react';
import {wedgeExactRole as r} from './wedgeRoles.js';

export type WedgeSettingsDeskLook = 'settingsdesk-row' | 'settingsdesk-row-on' | 'settingsdesk-request';
export const isWedgeSettingsDeskLook = (look: string): look is WedgeSettingsDeskLook => look.startsWith('settingsdesk-');

/* The desktop Settings screen. A category row is a full-width 15px line in the left list: the idle row is muted ink on no fill, the open
   row is accent ink on the soft accent wash with a heavier weight. The request action of the Join a team form is a mono caps pill on
   a solid blue fill that dims while it is busy or the domain is empty. None draws a transparent target: the rows touch each other in
   a stacked list, and the request pill is 44px tall. */
export function wedgeSettingsDeskStyle(look: WedgeSettingsDeskLook, disabled: boolean): CSSProperties {
  if (look === 'settingsdesk-request') return {
    minHeight: 44, font: 'inherit', fontFamily: r('mono'), fontSize: 11.5, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase',
    color: r('bg'), background: r('blue'), border: `1px solid ${r('blue')}`, borderRadius: 999, padding: '0 20px',
    cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.6 : 1,
  };
  const on = look === 'settingsdesk-row-on';
  return {
    display: 'flex', alignItems: 'center', gap: 11, width: '100%', padding: '9px 10px', borderRadius: 10, border: 0,
    background: on ? r('accentSoft') : 'transparent', color: on ? r('accent') : r('labelSec'),
    cursor: 'pointer', textAlign: 'left', fontFamily: r('font'), fontSize: 15, fontWeight: on ? 600 : 500,
  };
}
